/*global chai, controllers, describe, it, after, before*/
var expect = chai.expect;

describe('Welcome', function() {
    before(function(done){
      controllers.login._doConnect("admin", "admin", done) ;
    }) ;

    it('should display welcome', function(done) {
      if(controllers.welcome.view.isDisplayed()){
        return done() ;
      }
      controllers.welcome.view.once('displayed', function(){done() ;}) ;
    }) ;
    

    after(function(done){
      controllers.login.api.logout(done) ;
    }) ;
});